import "./styles.scss";

import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";

import { useNewWebsite } from "context/client/new_website";

import ModalNew from "components/ModalNew";
import FormikInput from "components/formik/FormikInput";
import FormikPhoneInput from "components/formik/FormikPhoneInput";
import Button from "components/Button";

import contactDataSchema from "libs/validations/new_website_form/contactDataSchema";

const mainClass = "new-website-content__widget__contact";

const ContactModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const { saveData, form_data } = useNewWebsite();

  const onSubmit = (values) => {
    saveData(values);

    if (typeof onClose === "function") onClose();
  };

  return (
    <ModalNew
      title={t("Change contact data")}
      variant="wide"
      hasMobileScrollTop={false}
      isOpen={isOpen}
      isSubmitHidden
      onClose={onClose}
    >
      <Formik
        initialValues={{
          first_name: form_data?.first_name || "",
          last_name: form_data?.last_name || "",
          email: form_data?.email || "",
          phone: {
            code: form_data?.phone?.code || "",
            number: form_data?.phone?.number || "",
          },
        }}
        validationSchema={contactDataSchema}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit(values, setSubmitting);
        }}
      >
        {({ isSubmitting }) => (
          <Form className={mainClass} autoComplete="off">
            <div className={`${mainClass}__form`}>
              <FormikInput
                name="first_name"
                label={t("Name")}
                placeholder={t("John")}
                disabled={isSubmitting}
                required
              />
              <FormikInput
                name="last_name"
                label={t("Surname")}
                placeholder={t("Doe")}
                disabled={isSubmitting}
                required
              />
              <FormikInput
                name="email"
                type="email"
                label={t("Email")}
                placeholder={t("j.doe@domain.com")}
                disabled={isSubmitting}
                required
              />
              <FormikPhoneInput
                label={t("Phone")}
                name="phone"
                placeholder="123 456 789"
                required
                disabled={isSubmitting}
              />
            </div>
            <div className={`${mainClass}__cta`}>
              <Button type="submit">{t("Update data")}</Button>
            </div>
          </Form>
        )}
      </Formik>
    </ModalNew>
  );
};

export default ContactModal;
